import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./radio-group.less"
import createReactClass from "create-react-class"

export default createReactClass({
  propTypes: {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    collection: PropTypes.array.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  },
  getInitialState: function () {
    return {
      value: this.props.value,
    }
  },
  onChange(event) {
    var value = event.target.value
    if (typeof this.props.onChange == "function") {
      this.props.onChange(event, value)
    }
    this.setState({ value: value })
  },
  isOptionDisabled(id) {
    if (!id) return false
    var ind = this.props.collection
      .map(function (x) {
        return x.id
      })
      .indexOf(id)
    return this.props.collection[ind].disabled
  },
  getClass() {
    return classnames(styles.easRadioGroup, this.props.className)
  },
  getDisabled(id) {
    return this.props.disabled || this.isOptionDisabled(id)
  },
  getLabelClass(id) {
    return classnames({
      [styles.checked]: id == this.state.value,
      [styles.disabled]: this.props.disabled || this.isOptionDisabled(id),
    })
  },
  render() {
    return (
      <div className={this.getClass()}>
        {this.props.collection.map((option) => {
          return (
            <div
              className={styles.radio}
              key={option.id}
              onChange={this.onChange}
              value={this.state.value}>
              <label className={this.getLabelClass(option.id)} data-qa={`label-${option.dataQa}`}>
                <input
                  data-qa={option.dataQa}
                  type="radio"
                  name={this.props.name}
                  value={option.id}
                  disabled={this.getDisabled(option.id)}
                />
                {option.title}
              </label>
            </div>
          )
        })}
      </div>
    )
  },
})
